import { MESSAGES_COLLECTION } from 'constants/firebase';
import { db } from 'services/firebase';
import { FetchResponse } from 'models';
import Mapper from 'data/Mapper';
import moment, { Moment } from 'moment';
import DataBase from '.';

class Messages extends DataBase {
  getDates(): Promise<FetchResponse<Moment[]>> {
    return db
      .collection(this.collection)
      .get()
      .then((snapshot) => {
        const data: Moment[] = [];
        snapshot.forEach((doc) =>
          data.push(moment.unix(doc.data().date.seconds)),
        );
        return Mapper.mapSuccesResponse(data);
      })
      .catch((error) => {
        return Mapper.mapError(error);
      });
  }
}

export default new Messages(MESSAGES_COLLECTION);
